/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiPartnerCodeDetail.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-partner-code-detail";

export class AutogenModelEdiPartnerCodeDetail<RowType extends ModelRow> extends Endpoint<RowType, RowEdiPartnerCodeDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiPartnerCodeDetail extends ModelRow<RowEdiPartnerCodeDetailFields> {
	constructor(values?: Partial<RowEdiPartnerCodeDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiPartnerCodeDetailFields {
	code_enabled: string;
	company_id: string;
	description: string;
	element_id: string;
	fault_of_carrier_or_driver: string;
	id: string;
	include_mobile_pu: string;
	include_mobile_so: string;
	partner_id: string;
	send_to_driver: string;
	standard_code: string;
	transaction_set: string;
	version: string;
}

